export const MAX_CHAT_FILE_SIZE_MB = 25;
export const CHAT_MESSAGE_MAX_LENGTH = 1000;
export const FETCH_OLDER_CHAT_MESSAGE_THRESHOLD = 500;
export const CHAT_ROOMS_LIMIT = 12;
export const CONSULTANT_CHAT_USER_NAME = 'INNOVATORS CAREER';
